module.exports = __webpack_public_path__ + "img/carlson-high-logo.935dd762.png";